module.exports = __webpack_public_path__ + "img/t-28430-003.4b4d00e3.jpg";